import React, { useEffect, useState } from 'react'
import { Box, Button, IconButton, TextField } from '@mui/material'
import styles from '../modal.module.css'
import ClearIcon from '@mui/icons-material/Clear';
import * as api from '../../../pages/services/api'
import Loader from 'components/Loader';

function ModalDeleteName({ onClose, data, onSubmit }) {

    const [loading, setLoading] = useState(false)
    const [detail, setDetail] = useState([])
    const [remark, setRemark] = useState('')

    useEffect(() => {
        console.log(data)
        setDetail(data)
    }, [])

    const handleClickLeave = () => {
        let list = {
            "year": detail['year'],
            "project_code": detail['project_code'],
            "pid": detail['pid'],
            "remark": remark
        }
        // console.log(list)
        leaveProject(list)
    }

    const leaveProject = async (list_) => {
        setLoading(true)
        let res = await api.leaveProject(list_)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                //alert(res['data']['message'])
                onSubmit()
                onClose()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <>
                <Loader loading={loading} />
                <Box className={styles.backgroundModal}>
                    <Box className={styles.boxModal}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                <Box sx={{ border: '5px solid #E06262' }} />
                                <Box sx={{
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    color: '#E06262',
                                    "@media (max-width: 800px)": {
                                        fontSize: '16px',
                                    }
                                }}>ลบรายชื่อ</Box>
                            </Box>
                            <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                                <IconButton onClick={() => { onClose() }}>
                                    <ClearIcon />
                                </IconButton>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'grid', gridGap: '10px', margin: '10px 0' }}>
                            <Box>ยืนยันการลบรายชื่อของ “{detail['full_name']}” ใช่หรือไม่ ?</Box>
                            <Box>
                                <Box sx={{ fontWeight: 600 }}>สาเหตุของการลบ</Box>
                                <TextField
                                    fullWidth
                                    rows={4}
                                    multiline
                                    value={remark}
                                    onChange={(e) => { setRemark(e.target.value) }}
                                />
                            </Box>
                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant='contained'
                                    sx={{ backgroundColor: '#E06262' }}
                                    onClick={() => { handleClickLeave() }}
                                >ยืนยันการลบ</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </>
        </>
    )
}

export default ModalDeleteName
